import React from 'react';
export function ProblemSection() {
  const problems = ['Domingos perdidos buscando material que nunca se adapta al currículo argentino', 'Clases improvisadas sin secuencia ni estructura clara', 'Evaluaciones armadas a las corridas, sin rúbricas ni criterios', 'Planificaciones para directivos hechas la noche anterior'];
  return <section className="w-full bg-black py-10 sm:py-14 px-4" data-id="element-118">
      <div className="max-w-3xl mx-auto text-center" data-id="element-119">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-8" data-id="element-120">
          Si sos docente de Inglés,
          <br data-id="element-121" />
          <span className="text-[#FF6B00]" data-id="element-122">esto te va a sonar familiar:</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left mb-10" data-id="element-123">
          {problems.map((text, i) => <div key={i} className="flex items-start gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-124">
              <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-125">❌</span>
              <p className="text-white text-base sm:text-lg font-medium leading-snug" data-id="element-126">
                {text}
              </p>
            </div>)}
        </div>

        <p className="text-[#FF6B00] text-xl sm:text-3xl font-black mb-8" data-id="element-127">
          ¿Cuántos domingos más vas a perder?
        </p>

        <div className="h-px bg-gradient-to-r from-transparent via-[#FF6B00] to-transparent w-full" data-id="element-128" />
      </div>
    </section>;
}